{
  "app": { "title": "85AI Finance & Accounting" },
  "tab": { "aria": "Main navigation" },
  "nav": { "home": "Home", "capture": "Record", "list": "Records", "reports": "Reports", "more": "More", "back": "Back" },
  "more": { "heading": "More", "settings": "Settings", "evidence": "Proof gallery" },
  "settings": { "heading": "Settings", "font": "Text size", "font_std": "Standard", "font_lg": "Large", "font_xl": "Extra large", "font_note": "Larger text is easier to read (this device only).", "language": "Language" },
  "proof": { "heading": "Proof", "camera": "Camera", "file": "Upload file/PDF", "uploading": "Uploading…", "hint": "Take a photo or upload the document — the accountant and management rely on these." },
  "evidence": { "heading": "Proof gallery", "search": "Search", "search_hint": "purpose / doc no / party", "count": "{{files}} files · {{vouchers}} vouchers", "empty": "No proofs (try changing filters)" },
  "auth": {
    "heading": "Sign in",
    "phone": "Phone number",
    "pin": "PIN",
    "sign_in": "Sign in",
    "signing_in": "Signing in…",
    "sign_out": "Sign out",
    "failed": "Phone or PIN is incorrect"
  },
  "changepin": {
    "heading": "Set a new PIN",
    "note": "You must change your PIN on first login (the temporary PIN cannot be reused). At least 6 characters.",
    "current": "Current PIN (temporary)",
    "new": "New PIN",
    "confirm": "Confirm new PIN",
    "save": "Change PIN",
    "saving": "Saving…",
    "mismatch": "The two new PINs do not match"
  },
  "home": {
    "net": "Net (month)",
    "todo": "To-do",
    "todo_none": "Nothing pending 🎉",
    "heading": "Home",
    "entity": "Company",
    "expense": "Expenses this month",
    "income": "Income this month",
    "period": "Period: {{period}}",
    "pending_reimb": "Advances to reimburse: {{n}}",
    "capture_cta": "Capture expense",
    "income_cta": "Record income",
    "recent": "Recent entries",
    "list_cta": "All records",
    "report_cta": "Monthly report",
    "export_cta": "Export",
    "periods_cta": "Lock / audit",
    "profit_cta": "Profit split",
    "budget_cta": "Budget",
    "items_cta": "AR / AP",
    "bank_cta": "Bank rec",
    "assets_cta": "Fixed assets"
  },
  "capture": {
    "heading": "Capture expense",
    "open_camera": "Open camera",
    "pick_file": "Pick photo / PDF",
    "shoot": "Take photo",
    "flip": "Flip camera",
    "cancel": "Cancel",
    "retake": "Retake",
    "uploaded": "Uploaded {{kb}} KB (original kept in private storage)",
    "saved": "✅ Recorded: {{no}}",
    "back_home": "Back to home",
    "working": "Working…",
    "working_ocr": "OCR reading…",
    "failed": "Capture failed, please retry",
    "denied": "Cannot open camera ({{msg}}) — you can use “Pick photo”",
    "upload_failed": "Upload failed: {{msg}}",
    "guide": "Fit the receipt in the frame; tap the screen to lock focus",
    "detected": "Document detected — hold still (auto-capture)",
    "auto": "Auto-capture: on / off",
    "opening": "Opening camera…",
    "hold": "Document found — hold still",
    "scan_error": "Detection error: {{msg}}",
    "manual_hint": "Photo = the frame; tap 🤖 to auto-find and auto-shoot",
    "adjust_hint": "Drag the 4 corners onto the receipt, then tap Apply",
    "apply": "Apply"
  },
  "ocr": {
    "heading": "OCR auto-fill",
    "reading": "Reading the receipt… (about 3–10 s)",
    "done": "Read in {{ms}} ms, about {{neurons}} neurons",
    "failed": "OCR failed: {{msg}} — you can still fill it in manually",
    "machine_hint": "🤖 Fields marked like this were read by the machine — please double-check before saving (especially amount and date).",
    "show_raw": "Show raw OCR text",
    "hide_raw": "Hide raw text"
  },
  "expense": {
    "amount": "Amount (HK$)",
    "date": "Date",
    "category": "Category",
    "purpose": "Purpose",
    "purpose_hint": "e.g. taxi to JHC meeting",
    "supplier": "Supplier / payee",
    "supplier_hint": "Type to see suggestions (a new name is created on the fly)",
    "entity": "Company",
    "paid_by": "Paid by",
    "paid_by_simon": "Simon (personal advance)",
    "paid_by_raymond": "Raymond (personal advance)",
    "paid_by_company": "Company",
    "payment_method": "Payment method",
    "account": "Paid from account",
    "project": "Project",
    "save": "Save voucher"
  },
  "method": {
    "cash": "Cash",
    "bank_transfer": "Bank transfer",
    "fps": "FPS",
    "cheque": "Cheque",
    "credit_card": "Credit card",
    "debit_card": "Debit card",
    "ewallet": "E-wallet",
    "auto_debit": "Auto debit",
    "none": "N/A"
  },
  "income": {
    "heading": "Record income",
    "category": "Income category",
    "account": "Received into",
    "entity": "Company",
    "customer": "Customer / source",
    "customer_hint": "e.g. JHC / roadshow name / B2B client",
    "doc_no": "Invoice / document no.",
    "attach": "Attach invoice / deposit slip",
    "attached": "1 file attached",
    "save": "Save income"
  },
  "items": {
    "heading": "Receivables / Payables",
    "kind": "Type",
    "kind_ar": "Receivable (customer owes us)",
    "kind_ap": "Payable (we owe supplier)",
    "party": "Customer / supplier",
    "issue_date": "Issue date",
    "due_date": "Due date",
    "amount": "Amount (HK$)",
    "income_code": "Income account",
    "expense_code": "Expense account",
    "create_ar": "Issue receivable (posts JV)",
    "create_ap": "Record payable (posts JV)",
    "note": "Issuing posts a voucher immediately (AR: Dr receivable/Cr income; AP: Dr expense/Cr payable) so the books and reports stay correct; later receipts/payments post another voucher to settle.",
    "created": "✅ Issued, voucher {{no}}",
    "settled": "✅ Settled, voucher {{no}} (balance {{balance}})",
    "settle_amount_needed": "Enter the amount received/paid",
    "account_needed": "Pick a bank/cash account",
    "open_list": "Open items",
    "settle_account": "Bank / cash account",
    "due": "due {{date}}",
    "settle_amount": "This payment",
    "receive": "Receive",
    "pay": "Pay",
    "aging": "Aging (by due date)",
    "current": "Not due",
    "balance": "Balance",
    "total": "Total"
  },
  "budget": {
    "heading": "Budget vs actual",
    "expense_budget": "Expense budget",
    "expense_actual": "Expense actual",
    "income_budget": "Income budget",
    "income_actual": "Income actual",
    "budget": "Budget (HK$)",
    "actual": "Actual",
    "variance": "Variance",
    "save": "Save budget",
    "saved": "✅ {{n}} budget lines updated (audited)",
    "note": "Budgets are planning data (editable, every change audited); actuals always come from journal lines — same source as the monthly report.",
    "unbudgeted": "actual without budget",
    "bad_amount": "Bad amount: {{v}} (max 2 decimals)",
    "no_changes": "Nothing changed"
  },
  "list": {
    "heading": "Transactions",
    "back_home": "Back to home",
    "month": "Month",
    "kind": "Type",
    "all": "All",
    "kind_payment": "Expense",
    "kind_receipt": "Income",
    "search": "Search",
    "search_hint": "purpose / doc no. / supplier",
    "loading": "Loading…",
    "count": "{{n}} records",
    "empty": "No records yet",
    "net": "Net {{amount}}",
    "pending_reimb": "to reimburse"
  },
  "detail": {
    "back": "Back to list",
    "amount": "Amount",
    "status": "Status",
    "status_confirmed": "Confirmed",
    "status_draft": "Draft",
    "status_locked": "Locked",
    "status_voided": "Voided",
    "lines": "Journal lines (Dr / Cr)",
    "gl": "Account",
    "dr": "Dr",
    "cr": "Cr",
    "balanced": "Σ Dr = Σ Cr (enforced by the database)",
    "attachments": "Attachments ({{n}})",
    "no_attachment": "No attachment",
    "ocr_meta": "Model: {{model}} | confidence: {{confidence}}",
    "raw_note": "The raw OCR text and full JSON are stored in the DB table `ocr_extractions` (auditable).",
    "void_heading": "Void (red reversal)",
    "void_reason": "Reason",
    "void_reason_hint": "e.g. wrong amount / duplicate entry",
    "void_cta": "Confirm void (create reversal)",
    "void_note": "Voiding **never deletes** the original: it is marked voided and a reversal voucher with mirrored entries is created (both stay, auditable).",
    "void_already": "This voucher is already voided (create a new voucher to correct instead)",
    "void_done": "Voided. Reversal: {{no}}",
    "open_reversal": "Open reversal voucher",
    "voided_by": "Voided by",
    "reversal_of": "Reversal of"
  },
  "periods": {
    "heading": "Accounting periods / month-end lock",
    "status": "Status",
    "locked": "Locked",
    "open": "Open",
    "locked_at": "Locked at",
    "lock": "Lock",
    "unlock": "Unlock",
    "empty": "No periods yet (one opens automatically with the first voucher)",
    "note": "Locking = no new entries or voids in that month (post adjustments next month) — used for month-end close.",
    "audit_heading": "Audit chain verification",
    "audit_cta": "Verify audit chain",
    "audit_ok": "✅ Audit chain intact ({{n}} entries)",
    "audit_bad": "❌ Audit chain broken at {{at}} ({{reason}})",
    "audit_note": "Each entry hash includes the previous hash → changing any entry breaks all later checks (detectable, provable)."
  },
  "profit": {
    "heading": "Profit allocation (trial)",
    "all_entities": "Combined (both companies)",
    "ai85_pct": "85 AI share (%)",
    "parties": "85% parties (name:%)",
    "parties_hint": "e.g. Simon:60,Raymond:25 (blank = settings/placeholder)",
    "readonly_note": "This page is a **trial only — it never posts journals** (policy pending; see decisions/006). You can change the split and parties on the fly.",
    "net": "Net profit",
    "by_entity": "By company",
    "allocation": "Allocation trial",
    "no_allocation": "Net profit ≤ 0 → no allocation",
    "party": "Party",
    "total": "Total",
    "posting_disabled": "⏳ Posting (journals) waits for the owner's decision: 85% parties / per-entity vs combined / transfer vs book allocation."
  },
  "report": {
    "heading": "Monthly report",
    "net": "Net",
    "locked": "⚠️ This month is locked (no new entries; post adjustments next month)",
    "by_category_expense": "Expenses by category",
    "by_category_income": "Income by category",
    "by_paid_by": "By payer",
    "by_method": "By payment method",
    "by_project": "By project",
    "by_month": "By month (no month selected)",
    "reimb": "Director advances to reimburse",
    "reimb_none": "Nothing to reimburse ✅",
    "reimb_pending": "pending {{amount}} ({{n}})",
    "reimb_settled": "settled {{amount}}"
  },
  "export": {
    "heading": "Export",
    "mode": "Range",
    "mode_month": "By month",
    "mode_range": "By date range",
    "from": "From",
    "to": "To",
    "xlsx_cta": "⬇️ Download Excel",
    "pack_cta": "🗂️ Download voucher pack (ZIP)",
    "xlsx_what": "Excel with 4 sheets: detail / monthly summary / account totals / advances",
    "pack_what": "Voucher pack: Excel + receipt images (filename = voucher no.) + manifest.csv (with sha256)",
    "note": "Both downloads require a session (never public). Hand it to the accountant as-is."
  },
  "bank": {
    "heading": "Bank reconciliation",
    "entity": "Company",
    "account": "Bank / cash account",
    "sync_meta": "Account list comes from the master data (`meta.accounts`); add accounts there first.",
    "status": "Status",
    "status_all": "All",
    "status_unmatched": "Unmatched",
    "status_matched": "Matched",
    "status_ignored": "Ignored",
    "import_heading": "Import statement (CSV / TSV)",
    "import_hint": "Export CSV from your bank's website/App (or save Excel as CSV) → open → copy → paste below. A header row is required (date + amount, or deposit/withdrawal).",
    "import_cta": "Import & de-duplicate",
    "csv_needed": "Paste the CSV content first",
    "imported": "✅ Imported {{imported}} rows, skipped {{skipped}} duplicates",
    "import_errors": "⚠️ {{n}} row(s) could not be parsed (never silently dropped, see below)",
    "line_count": "{{n}} row(s)",
    "txn_date": "Date",
    "description": "Description",
    "amount": "Amount",
    "direction_in": "Deposit",
    "direction_out": "Withdrawal",
    "suggestions": "Match suggestions",
    "no_suggestion": "No automatic suggestion (record the entry first, or use Ignore)",
    "match": "Match",
    "matched": "✅ Matched: {{no}}",
    "ignore": "Ignore",
    "ignore_reason": "Reason for ignoring",
    "ignore_reason_hint": "e.g. bank charge not yet recorded",
    "ignore_cta": "Confirm ignore",
    "ignored": "Ignored: {{reason}}",
    "reason_needed": "Please give a reason (≥3 chars)",
    "all_done": "This row has already been handled",
    "report_heading": "Reconciliation report",
    "statement_closing": "Statement closing balance",
    "statement_source": "Source: {{src}}",
    "book_balance": "Book balance (this account)",
    "difference": "Difference (statement − book)",
    "unmatched_statement": "Unmatched statement rows ({{n}})",
    "unmatched_book": "Unmatched book rows ({{n}})",
    "net": "Net",
    "empty": "No data yet",
    "explain": "The difference equals the net of both sides' unmatched items — i.e. what needs explaining (not yet recorded / not yet cleared / charges). Reconciliation never changes the books.",
    "voucher": "Voucher"
  },
  "dist": {
    "heading": "Profit distribution posting (P2-2; policy approved)",
    "entity": "Company",
    "period": "Period (must be locked)",
    "coleadery_pct": "CoLeadery % (10–20)",
    "marketing_pct": "Marketing special account % (40–50)",
    "note": "Policy (approved): Medical fund 15% / CoLeadery 20% / CoLinkery 10% / Marketing special account 40% (= 85%) + 85 AI Technology 15%. CoLeadery (10–20%) and Marketing (40–50%) can be adjusted per run, but the two must add up to 60% (so the five items total 100%).",
    "preview": "Preview (no posting)",
    "income": "Income",
    "expense": "Expenses",
    "net": "Net profit",
    "locked": "✅ Period is locked (posting allowed)",
    "not_locked": "⚠️ Period not locked (posting blocked)",
    "target": "Allocate to",
    "code": "Account",
    "amount": "Amount",
    "total": "Total",
    "from_retained": "(from retained earnings)",
    "already": "⚠️ This period is already posted ({{amount}}) — one posting per period; to correct, reverse that voucher.",
    "loss": "⚠️ Net profit ≤ 0 (loss) → nothing is distributed.",
    "post": "Post distribution (creates JV)",
    "posted": "✅ Posted {{no}}: {{amount}}",
    "post_note": "Posting creates one JV: Dr retained earnings / Cr the five targets (one line each, Σ = net profit). ⚠️ This is an equity appropriation — it never touches the P&L.",
    "history": "Distribution history",
    "base_net": "Base (net profit)"
  },
  "assets": {
    "heading": "Fixed assets (depreciation)",
    "entity": "Company",
    "status": "Status",
    "status_active": "In use",
    "status_disposed": "Disposed",
    "status_all": "All",
    "count": "{{n}} in use",
    "cost": "Cost",
    "accumulated": "Accum. depreciation",
    "book_value": "Net book value",
    "monthly": "Monthly",
    "this_period": "This period",
    "total": "Total",
    "remaining_months": "{{n}} months left",
    "create_heading": "Add asset",
    "name": "Asset name",
    "name_hint": "e.g. MacBook Pro M4 (design)",
    "category": "Category",
    "acquired_date": "Acquired",
    "salvage": "Salvage value",
    "life_months": "Useful life (months)",
    "create": "Add asset (auto no. FA-YYYY-MM-####)",
    "created": "✅ Asset added",
    "form_note": "Straight line: monthly = (cost − salvage) ÷ life months; the final month trues up the remainder (Σ depreciation = cost − salvage). Charges start in the month of acquisition.",
    "dep_heading": "Monthly depreciation (one voucher per period)",
    "period": "Period",
    "preview": "Preview (no posting)",
    "post": "Post depreciation (creates JV)",
    "posted": "✅ Posted {{no}}: {{amount}} ({{n}} assets)",
    "already_posted": "⚠️ This period is already posted ({{no}}) — one posting per period; to correct, reverse that voucher (red-letter).",
    "nothing": "No assets to depreciate this period (not acquired yet / fully depreciated / disposed) — no empty voucher is created.",
    "post_note": "Posting creates one JV: Dr 5210 Depreciation expense / Cr 1390 Accumulated depreciation (one pair of lines per asset, fully traceable). Depreciation is an expense (affects the 85:15 split) but no cash moves.",
    "list_heading": "Asset register",
    "asset_no": "Asset no.",
    "proceeds": "Proceeds",
    "dispose": "Dispose (sell / scrap)",
    "disposed": "✅ Disposed {{no}}: net book value {{book}}, gain {{gain}}",
    "runs": "Depreciation postings",
    "run_detail": "{{n}} assets"
  }
}
